import { render, staticRenderFns } from "./FacebookPixelModal.vue?vue&type=template&id=c0c87224&scoped=true&"
import script from "./FacebookPixelModal.vue?vue&type=script&lang=js&"
export * from "./FacebookPixelModal.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPixelModal.vue?vue&type=style&index=0&id=c0c87224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c87224",
  null
  
)

export default component.exports